// DmRow — a DM is a PLACE (spec §1 / §3).
//
// One continuous conversation per person. Never resolved, never assigned. A DM
// is rendered by PERSON, never by id — the `with` field is the person's name.
// No resolve/assign controls ever (fn_thread_assign on a DM raises "a DM has no
// owner — it is a conversation with a person"). No client-facing marker — a DM
// is two people, not client-facing by definition.
import React from "react";
import { formatWhen, fmtNumber } from "../../shared/format";

/**
 * @param {object} props
 * @param {object} props.dm   { id, with, messages, first_at, last_at }
 * @param {boolean} props.selected
 * @param {(id: string) => void} props.onSelect
 */
export default function DmRow({ dm, selected, onSelect }) {
  const d = dm || {};
  return (
    <button
      type="button"
      data-testid="dm-row"
      data-dm-id={d.id}
      aria-current={selected ? "page" : undefined}
      onClick={() => onSelect(d.id)}
      className={`flex w-full items-center gap-2 rounded-lg border-l-4 border-l-transparent px-3 py-2 text-left text-sm transition-colors ${
        selected
          ? "bg-[#32B1FF]/10 text-gray-900 dark:text-gray-100"
          : "text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800"
      }`}
    >
      <span className="h-2 w-2 shrink-0 rounded-full bg-emerald-500" aria-hidden="true" />
      <span className="truncate font-medium">{d.with || "Direct message"}</span>
      <span className="ml-auto flex shrink-0 items-center gap-2 text-xs text-gray-400">
        {typeof d.messages === "number" && (
          <span className="tabular-nums">{fmtNumber(d.messages)}</span>
        )}
        {d.last_at && <span className="tabular-nums">{formatWhen(d.last_at)}</span>}
      </span>
    </button>
  );
}
